export default __webpack_public_path__ + "static/media/WEBEnergizeOysterExtract500x900.0bac8580.jpg";